module.exports = __webpack_public_path__ + "excl-white.svg?608f49c5eae24bff8372b12e98396764";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/excl-white.svg
// module id = 934
// module chunks = 0